<div
  class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4"
>
  <div>
    <h1 class="text-2xl font-bold text-gray-800 dark:text-white">
      {{ titulo }}
    </h1>
    <p class="text-sm text-gray-500 dark:text-gray-400">
      Organiza tus tareas visualmente y optimiza tu flujo de trabajo
    </p>
  </div>

  <div
    class="flex bg-white dark:bg-gray-800 rounded-lg p-1 shadow-sm border border-gray-200 dark:border-gray-700"
  >
    <button
      (click)="vistaLista()"
      class="px-4 py-2 text-sm font-medium rounded-md text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
    >
      Lista
    </button>
    <button
      (click)="vistaKanban()"
      class="px-4 py-2 text-sm font-medium rounded-md bg-brand-50 dark:bg-brand-900/30 text-brand-600 dark:text-brand-400 shadow-sm"
    >
      Kanban
    </button>
    <button
      (click)="vistaCalendario()"
      class="px-4 py-2 text-sm font-medium rounded-md text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
    >
      Calendario
    </button>
  </div>
</div>

<div class="space-y-4">
  <!-- Nueva barra de filtros centralizada -->
  <app-task-filters
    (filterChanged)="onFilterChanged($event)"
    (createClicked)="nuevaTarea()"
  />

  <div class="flex items-center gap-2 mb-2 overflow-x-auto no-scrollbar py-1">
    <div
      class="flex bg-gray-100 dark:bg-gray-800 p-1 rounded-lg border dark:border-gray-700"
    >
      @for (m of availableModes; track m.v) {
        <button
          (click)="changeViewMode(m.v)"
          class="px-4 py-1.5 text-xs rounded-md font-bold transition-all whitespace-nowrap"
          [class]="
            viewMode === m.v
              ? 'bg-white dark:bg-gray-700 shadow-sm text-brand-600 dark:text-brand-400'
              : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'
          "
        >
          Organizar por {{ m.l }}
        </button>
      }
    </div>
  </div>

  @if (loading) {
    <div class="text-center py-8 text-sm text-gray-500 dark:text-gray-400">
      Cargando…
    </div>
  }

  <div class="kanban-container overflow-x-auto w-full pb-6">
    <div
      class="flex gap-4"
      style="min-width: fit-content"
    >
      @for (column of columns; track column.id) {
        <div
          class="bg-gray-100/50 dark:bg-gray-800/50 rounded-xl p-3 min-w-75 w-75 shrink-0 border border-transparent dark:border-gray-700/50"
        >
          <div class="flex items-center justify-between mb-4 px-1">
            <div class="flex items-center gap-2">
              <div
                class="w-2.5 h-2.5 rounded-full"
                [style.background-color]="column.hexColor"
              ></div>
              <h3
                class="font-bold text-sm text-gray-700 dark:text-gray-200 uppercase tracking-wider"
              >
                {{ column.label }}
              </h3>
            </div>
            <span
              class="text-[11px] font-bold text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-700 px-2 py-0.5 rounded-full shadow-sm"
            >
              {{ column.tasks.length }}
            </span>
          </div>

          <div
            cdkDropList
            [id]="'col-' + column.id"
            [cdkDropListData]="column.tasks"
            [cdkDropListConnectedTo]="getColumnIds()"
            (cdkDropListDropped)="drop($event, column)"
            class="min-h-150 max-h-175 overflow-y-auto space-y-3 rounded-lg"
          >
            @for (task of column.tasks; track task.id) {
              <div
                cdkDrag
                (click)="abrirDetalle(task.id!)"
                class="bg-white dark:bg-gray-900 rounded-lg p-3.5 shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-md hover:border-brand-300 dark:hover:border-brand-700 transition-all group relative cursor-grab active:cursor-grabbing"
              >
                <!-- Chips superiores: tipo, prioridad, categoría -->
                @let type = resolveType(task);
                @let priority = resolvePriority(task);
                @let category = resolveCategory(task);
                <div class="flex items-center gap-1.5 flex-wrap mb-2">
                  @if (type) {
                    <span
                      class="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-md text-white font-semibold shadow-sm"
                      [style.background-color]="type.color || '#6B7280'"
                    >
                      {{ type.label }}
                    </span>
                  }
                  @if (priority) {
                    <span
                      class="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-md font-medium border bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200"
                      [style.border-color]="priority.color || '#9CA3AF'"
                    >
                      <span
                        class="w-1.5 h-1.5 rounded-full shrink-0"
                        [style.background-color]="priority.color || '#9CA3AF'"
                      ></span>
                      {{ priority.label }}
                    </span>
                  }
                  @if (category) {
                    <span
                      class="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-md font-medium border bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200"
                      [style.border-color]="category.color || '#6B7280'"
                    >
                      <span
                        class="w-1.5 h-1.5 rounded-full shrink-0"
                        [style.background-color]="category.color || '#6B7280'"
                      ></span>
                      {{ category.name }}
                    </span>
                  }
                  @if (isOverdue(task)) {
                    <span
                      class="text-[10px] px-1.5 py-0.5 rounded-md bg-error-100 dark:bg-error-900/30 text-error-700 dark:text-error-400 font-medium"
                    >
                      ⚠ Vencida
                    </span>
                  }
                </div>

                <h4
                  class="font-bold text-gray-900 dark:text-white text-[13px] mb-2 pr-2 leading-snug group-hover:text-brand-500 dark:group-hover:text-brand-400 transition-colors"
                >
                  {{ task.title }}
                </h4>

                <div
                  class="flex items-center gap-2 text-[11px] mb-2 font-medium"
                  [class.text-error-600]="isOverdue(task)"
                  [class.dark:text-error-400]="isOverdue(task)"
                  [class.text-gray-500]="!isOverdue(task)"
                  [class.dark:text-gray-400]="!isOverdue(task)"
                >
                  <svg
                    class="w-3.5 h-3.5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                  <span>{{ formatDate(task.datetimeDue) }}</span>
                </div>

                <!-- Chips de asociaciones -->
                @if (hasAnyAssociation(task)) {
                  <div
                    class="flex flex-wrap gap-1 border-t border-gray-100 dark:border-gray-700/50 pt-2 mb-2"
                  >
                    @if (task.intIdCompany) {
                      <span
                        class="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-md bg-purple-50 dark:bg-purple-900/20 text-purple-700 dark:text-purple-300 border border-purple-200 dark:border-purple-800 max-w-full truncate"
                      >
                        <svg
                          class="w-2.5 h-2.5 shrink-0"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5"
                          />
                        </svg>
                        <span class="truncate">{{
                          companyName(task.intIdCompany)
                        }}</span>
                      </span>
                    }
                    @if (task.intIdDeal) {
                      <span
                        class="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-md bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800 max-w-full truncate"
                      >
                        <svg
                          class="w-2.5 h-2.5 shrink-0"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          />
                        </svg>
                        <span class="truncate">{{
                          dealName(task.intIdDeal)
                        }}</span>
                      </span>
                    }
                    @if (task.intIdLead) {
                      <span
                        class="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-md bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-300 border border-amber-200 dark:border-amber-800 max-w-full truncate"
                      >
                        <svg
                          class="w-2.5 h-2.5 shrink-0"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 10V3L4 14h7v7l9-11h-7z"
                          />
                        </svg>
                        <span class="truncate">{{
                          leadName(task.intIdLead)
                        }}</span>
                      </span>
                    }
                  </div>
                }

                <!-- Footer: progress de subtareas -->
                @if (task.subtaskCount && task.subtaskCount > 0) {
                  <div class="flex items-center justify-end gap-1.5 mt-2">
                    <span
                      class="text-[10px] font-bold text-gray-400 dark:text-gray-500"
                    >
                      {{ task.subtaskCompletedCount || 0 }}/{{
                        task.subtaskCount
                      }}
                    </span>
                    <div
                      class="w-10 h-1 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden"
                    >
                      <div
                        class="h-full bg-brand-500"
                        [style.width.%]="subtaskProgressPercent(task)"
                      ></div>
                    </div>
                  </div>
                }
              </div>
            }

            @if (column.tasks.length === 0) {
              <div
                class="text-center py-6 text-xs text-gray-400 dark:text-gray-600 italic"
              >
                Sin tareas
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Paginación -->
  @if (globalTotalPages >= 1) {
    <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4">
      <div class="flex items-center justify-between gap-4 flex-wrap">
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-500 dark:text-gray-400"
            >{{ globalTotalElements }} tareas</span
          >
          <select
            [ngModel]="pageSize"
            (ngModelChange)="changePageSize($event)"
            class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            @for (opt of PAGE_SIZE_OPTIONS; track opt) {
              <option [value]="opt">{{ opt }}</option>
            }
          </select>
        </div>
        <div class="flex items-center gap-2">
          <button
            type="button"
            (click)="cambiarPagina(globalPage - 1)"
            [disabled]="!hasPrevPage"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          >
            Anterior
          </button>
          <div class="flex items-center gap-1.5">
            <span class="text-sm text-gray-500 dark:text-gray-400">Página</span>
            <select
              [ngModel]="pageDisplay"
              (ngModelChange)="cambiarPagina($event - 1)"
              class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            >
              @for (p of pagesArray; track p) {
                <option [value]="p">{{ p }}</option>
              }
            </select>
            <span class="text-sm text-gray-500 dark:text-gray-400"
              >de {{ globalTotalPages }}</span
            >
          </div>
          <button
            type="button"
            (click)="cambiarPagina(globalPage + 1)"
            [disabled]="!hasNextPage"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          >
            Siguiente
          </button>
        </div>
      </div>
    </div>
  }
</div>

<!-- El drawer de tarea NO se monta aquí: AppLayout ya monta <app-task-form-drawer />
     globalmente y TaskDrawerService es providedIn:'root'. Montarlo otra vez creaba una
     segunda instancia suscrita al mismo state$ (dos formularios superpuestos). -->

<app-task-detail-modal
  [isOpen]="showDetailModal"
  [taskId]="detailTaskId"
  (closed)="cerrarDetalle()"
  (changed)="onDetailChanged()"
/>

<app-task-cancel-dialog
  [visible]="showCancelDialog"
  [task]="cancelTargetTask!"
  [reason]="cancelReasons"
  (closed)="showCancelDialog = false"
  (cancel)="aplicarCancelacion($event)"
/>

<app-task-complete-dialog
  [visible]="showCompleteDialog"
  [task]="completeTargetTask!"
  (closed)="showCompleteDialog = false"
  (complete)="aplicarCompletar($event)"
/>
